// extracted by mini-css-extract-plugin
export default {"sourcesCollapse":"sources-collapse_sourcesCollapse__0maJ4","sourcesExpenderIcon":"sources-collapse_sourcesExpenderIcon__TeWcx"};